// TODO This can be improved
export enum AttributeEnum {
  Carrier = 'Carrier',
  Client = 'Client',
  ClientProgram = 'ClientProgram',
  ClientSpecific = 'ClientSpecific',
  Functional = 'Functional',
  Global = 'Global',
  LineOfBusiness = 'Line of Business',
  Location = 'Location',
  State = 'State',
  UserType = 'UserType',
  IsExternal = 'IsExternal',
  'PLATFORM_APPS' = 'PLATFORM_APPS',
  Applications = 'Applications'
}
